import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { Sheet, SheetContent } from './components/ui/sheet';
import Sidebar from './components/Sidebar';
import NewAudit from './pages/NewAudit';
import Results from './pages/Results';
import History from './pages/History';
import Emails from './pages/Emails';
import SettingsPage from './pages/Settings';
import ActionTracker from './pages/ActionTracker';
import Login from './pages/Login';
import { Menu, ShieldCheck } from 'lucide-react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import './App.css';

function ProtectedShell() {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="animate-pulse text-sm text-slate-400">Loading…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return (
    <div className="app-shell">
      <div className="sidebar-desktop hidden lg:block">
        <Sidebar onNavigate={() => {}} />
      </div>
      <div className="mobile-topbar lg:hidden">
        <button onClick={() => setMobileOpen(true)} className="p-2 rounded-md hover:bg-secondary transition-colors">
          <Menu className="w-5 h-5" />
        </button>
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-primary flex items-center justify-center">
            <ShieldCheck className="w-3.5 h-3.5 text-primary-foreground" />
          </div>
          <span className="text-sm font-semibold" style={{ fontFamily: 'Space Grotesk' }}>Supply Chain Auditor</span>
        </div>
        <div />
      </div>
      <Sheet open={mobileOpen} onOpenChange={setMobileOpen}>
        <SheetContent side="left" className="p-0 w-[260px]">
          <Sidebar onNavigate={() => setMobileOpen(false)} />
        </SheetContent>
      </Sheet>
      <main className="main-content">
        <Routes>
          <Route path="/" element={<Navigate to="/new-audit" replace />} />
          <Route path="/new-audit" element={<NewAudit />} />
          <Route path="/results/:auditId" element={<Results />} />
          <Route path="/history" element={<History />} />
          <Route path="/action-tracker" element={<ActionTracker />} />
          <Route path="/emails" element={<Emails />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="*" element={<Navigate to="/new-audit" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<ProtectedShell />} />
        </Routes>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </Router>
  );
}
